import React from "react";
import "./Footer.css";
import rtr from "../assets/rtr.png";
import { Link } from "react-router-dom";
import buyruq from "../assets/buyruq.pdf"

export default function Footer() {
  return (
    <div className="footer">
      <div className="container-fluid">
        <div className="footer-flex">
          <div className="footer-logo">
            <div className="logo-box"></div>
            <div className="footer-rtr">
              <img src={rtr} alt="bu rasm" />
            </div>
          </div>
          <div className="footer-menu">
            <div className="footer-box">
              <Link to="/loyiha-haqida">Loyiha haqida</Link>
              <Link to="/rtr">Raqamli Ta’lim Resurslari</Link>
              <Link to={buyruq} target="blank">
                26.07.2023 329-son buyrug'i <br/>” Respublika ko‘rik-tanlovini
                o‘tkazish to‘g‘risida
              </Link>
            </div>
            <div className="footer-box">
              <Link to="/contact">Biz bilan bog‘lanish</Link>
              <Link to="/professiogramma">Professiogrammalar</Link>
            </div>
            <div className="footer-box">
              <Link to="/VideoMaterial">Video materiallar</Link>
            </div>
            <div className="footer-box">
              <a className="tel" href="tel:+998712469037">
                <svg
                  width="23"
                  height="23"
                  viewBox="0 0 23 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.8482 12.3517C17.7369 12.2402 17.6046 12.1517 17.459 12.0913C17.3135 12.031 17.1574 11.9999 16.9998 11.9999C16.8422 11.9999 16.6862 12.031 16.5406 12.0913C16.395 12.1517 16.2628 12.2402 16.1514 12.3517L14.2386 14.2645C13.3519 14.0005 11.6971 13.4005 10.6483 12.3517C9.59949 11.3029 8.9995 9.64814 8.7355 8.76135L10.6483 6.84857C10.7598 6.73723 10.8483 6.60498 10.9087 6.45941C10.969 6.31383 11.0001 6.15778 11.0001 6.00018C11.0001 5.84258 10.969 5.68653 10.9087 5.54095C10.8483 5.39538 10.7598 5.26313 10.6483 5.15179L5.84833 0.351838C5.73698 0.240304 5.60474 0.151819 5.45916 0.0914472C5.31359 0.031075 5.15754 0 4.99994 0C4.84234 0 4.68629 0.031075 4.54071 0.0914472C4.39513 0.151819 4.26289 0.240304 4.15155 0.351838L0.897179 3.60621C0.441183 4.0622 0.184386 4.68859 0.193985 5.32819C0.221585 7.03697 0.673981 12.9721 5.35153 17.6497C10.0291 22.3272 15.9642 22.7784 17.6742 22.8072H17.7078C18.3414 22.8072 18.9402 22.5576 19.3938 22.104L22.6482 18.8497C22.7597 18.7383 22.8482 18.6061 22.9086 18.4605C22.9689 18.3149 23 18.1589 23 18.0013C23 17.8437 22.9689 17.6876 22.9086 17.542C22.8482 17.3965 22.7597 17.2642 22.6482 17.1529L17.8482 12.3517ZM17.6958 20.406C16.1982 20.3808 11.0743 19.9788 7.04832 15.9517C3.00916 11.9125 2.61796 6.77057 2.59396 5.30299L4.99994 2.89701L8.10311 6.00018L6.55152 7.55177C6.41048 7.6927 6.30678 7.86657 6.24979 8.05764C6.1928 8.24872 6.18432 8.45098 6.22513 8.64615C6.25392 8.78415 6.95832 12.0565 8.9503 14.0485C10.9423 16.0405 14.2146 16.7449 14.3526 16.7737C14.5477 16.8156 14.7502 16.8078 14.9414 16.751C15.1327 16.6942 15.3065 16.5901 15.447 16.4485L16.9998 14.8969L20.103 18.0001L17.6958 20.406Z"
                    fill=""
                  />
                </svg>
                (+998) 71 246-90-37
              </a>
              <a className="email" href="mailto:kasbiytalim@edu.uz">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="23"
                  height="23"
                  fill="currentColor"
                  className="bi bi-envelope"
                  viewBox="0 0 16 16"
                >
                  <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" />
                </svg>
                kasbiytalim@edu.uz
              </a>
              <a
                className="location"
                href="https://yandex.uz/maps/org/81589415292/?ll=69.211024%2C41.353626&z=16"
              >
                <svg
                  width="23"
                  height="23"
                  viewBox="0 0 24 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_3_1207)">
                    <path
                      d="M12 17.9998C15.309 17.9998 17.9999 15.3088 17.9999 11.9999C17.9999 8.69091 15.309 5.99994 12 5.99994C8.69103 5.99994 6.00006 8.69091 6.00006 11.9999C6.00006 15.3088 8.69103 17.9998 12 17.9998ZM12 8.99991C13.6545 8.99991 15 10.3454 15 11.9999C15 13.6544 13.6545 14.9998 12 14.9998C10.3455 14.9998 9.00003 13.6544 9.00003 11.9999C9.00003 10.3454 10.3455 8.99991 12 8.99991Z"
                      fill=""
                    />
                    <path
                      d="M11.13 29.7207C11.3839 29.902 11.688 29.9994 12 29.9994C12.312 29.9994 12.6161 29.902 12.87 29.7207C13.326 29.3982 24.0434 21.6598 23.9999 11.9999C23.9999 5.38344 18.6164 0 12 0C5.38357 0 0.000132055 5.38344 0.000132055 11.9924C-0.0433675 21.6598 10.674 29.3982 11.13 29.7207ZM12 2.99997C16.9634 2.99997 20.9999 7.03642 20.9999 12.0074C21.0314 18.6643 14.418 24.6417 12 26.6022C9.58353 24.6402 2.9686 18.6613 3.0001 11.9999C3.0001 7.03642 7.03655 2.99997 12 2.99997Z"
                      fill=""
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_3_1207">
                      <rect width="24" height="29.9997" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                Toshkent shahar, Olmazor tumani, Talabalar ko‘chasi, 96-uy
              </a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>
            © 2026. Raqamli ta’lim resurslari platformasi. Barcha huquqlar
            himoyalangan.
          </p>
          <div className="footer-net">
            <Link>
              <svg
                width="24"
                height="26"
                viewBox="0 0 24 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M23.71 0.84158C23.575 0.70188 23.4045 0.605157 23.2185 0.562784C23.0325 0.52041 22.8388 0.534147 22.66 0.60238L0.660001 8.92238C0.470269 8.99722 0.306921 9.13033 0.191652 9.30401C0.0763829 9.4777 0.0146484 9.68374 0.0146484 9.89478C0.0146484 10.1058 0.0763829 10.3119 0.191652 10.4855C0.306921 10.6592 0.470269 10.7923 0.660001 10.8672L10.26 14.8608L14.1 24.8448C14.1721 25.0334 14.2958 25.196 14.4557 25.3124C14.6157 25.4289 14.8049 25.4941 15 25.5C15.2021 25.4957 15.3982 25.4278 15.5624 25.3052C15.7266 25.1827 15.8513 25.0113 15.92 24.8136L23.92 1.93358C23.9881 1.74958 24.0046 1.54923 23.9674 1.35588C23.9302 1.16254 23.8409 0.984175 23.71 0.84158ZM15 21.548L12.21 14.268L17 9.28638L15.59 7.81998L10.76 12.8432L3.8 9.89998L21.33 3.31678L15 21.548Z"
                  fill="#fdfdfd"
                />
              </svg>
            </Link>
            <Link>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M23.04 0H0.96C0.429 0 0 0.429 0 0.96V23.04C0 23.571 0.429 24 0.96 24H23.04C23.571 24 24 23.571 24 23.04V0.96C24 0.429 23.571 0 23.04 0ZM20.268 7.005H18.351C16.848 7.005 16.557 7.719 16.557 8.769V11.082H20.145L19.677 14.703H16.557V24H12.816V14.706H9.687V11.082H12.816V8.412C12.816 5.313 14.709 3.624 17.475 3.624C18.801 3.624 19.938 3.723 20.271 3.768V7.005H20.268Z"
                  fill="#FDFDFD"
                />
              </svg>
            </Link>
            <a>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.0018 5.84744C8.59683 5.84744 5.84883 8.59544 5.84883 12.0004C5.84883 15.4054 8.59683 18.1534 12.0018 18.1534C15.4068 18.1534 18.1548 15.4054 18.1548 12.0004C18.1548 8.59544 15.4068 5.84744 12.0018 5.84744ZM12.0018 15.9994C9.79983 15.9994 8.00283 14.2024 8.00283 12.0004C8.00283 9.79844 9.79983 8.00144 12.0018 8.00144C14.2038 8.00144 16.0008 9.79844 16.0008 12.0004C16.0008 14.2024 14.2038 15.9994 12.0018 15.9994ZM18.4068 4.16144C17.6118 4.16144 16.9698 4.80344 16.9698 5.59844C16.9698 6.39344 17.6118 7.03544 18.4068 7.03544C19.2018 7.03544 19.8438 6.39644 19.8438 5.59844C19.8441 5.40966 19.8071 5.22269 19.7349 5.04824C19.6628 4.87379 19.557 4.71528 19.4235 4.5818C19.29 4.44831 19.1315 4.34247 18.957 4.27034C18.7826 4.19821 18.5956 4.1612 18.4068 4.16144ZM23.9958 12.0004C23.9958 10.3444 24.0108 8.70344 23.9178 7.05044C23.8248 5.13044 23.3868 3.42644 21.9828 2.02244C20.5758 0.615437 18.8748 0.180437 16.9548 0.0874372C15.2988 -0.00556279 13.6578 0.00943725 12.0048 0.00943725C10.3488 0.00943725 8.70783 -0.00556279 7.05483 0.0874372C5.13483 0.180437 3.43083 0.618437 2.02683 2.02244C0.619832 3.42944 0.184832 5.13044 0.0918317 7.05044C-0.00116826 8.70644 0.0138318 10.3474 0.0138318 12.0004C0.0138318 13.6534 -0.00116826 15.2974 0.0918317 16.9504C0.184832 18.8704 0.622832 20.5744 2.02683 21.9784C3.43383 23.3854 5.13483 23.8204 7.05483 23.9134C8.71083 24.0064 10.3518 23.9914 12.0048 23.9914C13.6608 23.9914 15.3018 24.0064 16.9548 23.9134C18.8748 23.8204 20.5788 23.3824 21.9828 21.9784C23.3898 20.5714 23.8248 18.8704 23.9178 16.9504C24.0138 15.2974 23.9958 13.6564 23.9958 12.0004ZM21.3558 19.0744C21.1368 19.6204 20.8728 20.0284 20.4498 20.4484C20.0268 20.8714 19.6218 21.1354 19.0758 21.3544C17.4978 21.9814 13.7508 21.8404 12.0018 21.8404C10.2528 21.8404 6.50283 21.9814 4.92483 21.3574C4.37883 21.1384 3.97083 20.8744 3.55083 20.4514C3.12783 20.0284 2.86383 19.6234 2.64483 19.0774C2.02083 17.4964 2.16183 13.7494 2.16183 12.0004C2.16183 10.2514 2.02083 6.50144 2.64483 4.92344C2.86383 4.37744 3.12783 3.96944 3.55083 3.54944C3.97383 3.12944 4.37883 2.86244 4.92483 2.64344C6.50283 2.01944 10.2528 2.16044 12.0018 2.16044C13.7508 2.16044 17.5008 2.01944 19.0788 2.64344C19.6248 2.86244 20.0328 3.12644 20.4528 3.54944C20.8758 3.97244 21.1398 4.37744 21.3588 4.92344C21.9828 6.50144 21.8418 10.2514 21.8418 12.0004C21.8418 13.7494 21.9828 17.4964 21.3558 19.0744Z"
                  fill="white"
                />
              </svg>
            </a>
            <a>
              <svg
                width="24"
                height="18"
                viewBox="0 0 24 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M23.4699 2.93179C23.3335 2.39882 23.0663 1.91289 22.6951 1.52261C22.324 1.13234 21.8619 0.851413 21.355 0.707956C19.4884 0.176758 11.9879 0.176758 11.9879 0.176758C11.9879 0.176758 4.48729 0.176758 2.62071 0.707956C2.11385 0.851413 1.65172 1.13234 1.28057 1.52261C0.90941 1.91289 0.642248 2.39882 0.50582 2.93179C0.157288 4.93347 -0.0118455 6.96513 0.000644257 9.00005C-0.0118455 11.035 0.157288 13.0666 0.50582 15.0683C0.642248 15.6013 0.90941 16.0872 1.28057 16.4775C1.65172 16.8678 2.11385 17.1487 2.62071 17.2921C4.48729 17.8233 11.9879 17.8233 11.9879 17.8233C11.9879 17.8233 19.4884 17.8233 21.355 17.2921C21.8619 17.1487 22.324 16.8678 22.6951 16.4775C23.0663 16.0872 23.3335 15.6013 23.4699 15.0683C23.8184 13.0666 23.9876 11.035 23.9751 9.00005C23.9876 6.96513 23.8184 4.93347 23.4699 2.93179ZM9.59041 12.7815V5.21864L15.8152 9.00005L9.59041 12.7815Z"
                  fill="white"
                />
              </svg>
            </a>
            <div>
              <a href="https://t.me/XakimovS7" target={"_blank"}>
                Design: Сардорбек Хакимов
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
